import React from "react";
import MagazineRow from "../../rows/magazine-row";
import styles from "./styles.m.css";
import PropTypes from "prop-types";
import { InfiniteScroll } from "@quintype/components";
import { ReadMoreLink } from "../../atoms/read-more-link";
import { WebEngage, ComScore, DeepBI, GA, Chartbeat } from "../../../integrations";
import CollectionTitleWithCrossLine from "../../atoms/CollectionTitleWithCrossLine";
import { get } from "lodash";
import { addPagePathtoMagazineIssues } from "../../../data/entity";
import { PAGE_TYPE } from "../../../constants";

const MagazineListingRow = ({ magazine, showHeadLine = true, numberOfItems = 5 }) => {
  let issues = get(magazine, ["collections"], null);
  if (issues) {
    const items = issues.slice(0, numberOfItems);
    const LoadMoreLink = <ReadMoreLink text={"மேலும் படிக்க"} href={`/archive?magazine=${magazine.id}`} />;
    return (
      <div className={"container"}>
        <div className={styles["base"]}>
          {showHeadLine ? <CollectionTitleWithCrossLine title={magazine.name} className={styles["title"]} /> : null}
          <MagazineRow
            issues={items}
            next={LoadMoreLink}
            className={`${styles["magazine-row"]} ${styles["stretch"]}`}
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

MagazineListingRow.propTypes = {
  magazine: PropTypes.shape(MagazineRow.propTypes),
  numberOfItems: PropTypes.number
};

function MagazineIssueListingPage({ data, config }) {
  React.useEffect(() => {
    WebEngage.registerPageView();
    ComScore.registerPageView();
    DeepBI.loadScript();
    GA.registerPageView(PAGE_TYPE.MAGAZINE_LISTING_PAGE);
    Chartbeat.registerNonStoryPageView(PAGE_TYPE.MAGAZINE_LISTING_PAGE);
  }, []);
  const [magazinesShown, setMagazinesShown] = React.useState(data["magazines"]);
  const entities = data["entities"];
  const entityIdsNotShown = entities
    .filter(entity => {
      let shown = false;
      magazinesShown.forEach(magazine => {
        if (magazine.id === entity.id) {
          shown = true;
        }
      });
      return !shown;
    })
    .map(entity => entity.id);
  return (
    <div className={`main-page ${styles["main-container"]}`}>
      <InfiniteScroll
        render={magazine => <MagazineListingRow magazine={magazine} />}
        items={magazinesShown}
        loadNext={nextTwoMagazines}
        focusCallbackAt={20}
        loadMargin={"-2%"}
        onFocus={() => {}}
        neverHideItem={true}
      />
    </div>
  );

  function nextTwoMagazines() {
    function makeApiCall(entityId) {
      const queryParams = {
        "sort-by": "collection-date",
        limit: 5,
        order: "desc"
      };
      return global
        .wretch(`/api/v1/entity/${entityId}/collections`)
        .query(queryParams)
        .get()
        .json(response => {
          return addPagePathtoMagazineIssues(response, config);
        });
    }
    const entitiesToBeConsidered = entityIdsNotShown.splice(0, 6);
    Promise.all(entitiesToBeConsidered.map(entityId => makeApiCall(entityId))).then(magazines => {
      setMagazinesShown([...magazinesShown, ...magazines]);
    });
  }
}

MagazineIssueListingPage.propTypes = {
  data: PropTypes.shape({
    magazines: PropTypes.arrayOf(PropTypes.shape(MagazineListingRow.propTypes)),
    entities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        slug: PropTypes.string,
        name: PropTypes.string
      })
    )
  }),
  config: PropTypes.shape({
    magazines: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        id: PropTypes.number
      })
    )
  })
};

export { MagazineIssueListingPage, MagazineListingRow };
